{
  "byToken": {
    "Move+1": {
      "category": "movement",
      "name": "Move+1",
      "rarity": "common"
    },
    "Move+2": {
      "category": "movement",
      "name": "Move+2",
      "rarity": "common"
    },
    "Move+3": {
      "category": "movement",
      "name": "Move+3",
      "rarity": "uncommon"
    },
    "Jump+1": {
      "category": "movement",
      "name": "Jump+1",
      "rarity": "common"
    },
    "Jump+2": {
      "category": "movement",
      "name": "Jump+2",
      "rarity": "common"
    },
    "Jump+3": {
      "category": "movement",
      "name": "Jump+3",
      "rarity": "common"
    },
    "Lifefont": {
      "category": "movement",
      "name": "Lifefont",
      "rarity": "common"
    },
    "Teleport": {
      "category": "movement",
      "name": "Teleport",
      "rarity": "common"
    },
    "Levitate": {
      "category": "movement",
      "name": "Levitate",
      "rarity": "common"
    },
    "Pilgrimage": {
      "category": "movement",
      "name": "Pilgrimage",
      "rarity": "common"
    },
    "Manafont": {
      "category": "movement",
      "name": "Manafont",
      "rarity": "common"
    },
    "IgnoreTerrain": {
      "category": "movement",
      "name": "Ignore Terrain",
      "rarity": "common"
    },
    "LavaWalking": {
      "category": "movement",
      "name": "Lava Walking",
      "rarity": "common"
    },
    "IgnoreHeight": {
      "category": "movement",
      "name": "Ignore Height",
      "rarity": "common"
    },
    "Swim": {
      "category": "movement",
      "name": "Swim",
      "rarity": "common"
    },
    "Waterwalking": {
      "category": "movement",
      "name": "Waterwalking",
      "rarity": "common"
    },
    "Fly": {
      "category": "movement",
      "name": "Fly",
      "rarity": "common"
    },
    "Retreat": {
      "category": "movement",
      "name": "Retreat",
      "rarity": "common"
    },
    "SonicStep": {
      "category": "movement",
      "name": "Sonic Step",
      "rarity": "common"
    },
    "AttackUp": {
      "category": "support",
      "name": "Attack Up",
      "rarity": "common"
    },
    "DefenseUp": {
      "category": "support",
      "name": "Defense Up",
      "rarity": "common"
    },
    "MagicAttackUp": {
      "category": "support",
      "name": "Magic Attack Up",
      "rarity": "common"
    },
    "MagicDefenseUp": {
      "category": "support",
      "name": "Magic Defense Up",
      "rarity": "common"
    },
    "Concentrate": {
      "category": "support",
      "name": "Concentrate",
      "rarity": "common"
    },
    "MartialArts": {
      "category": "support",
      "name": "Martial Arts",
      "rarity": "common"
    },
    "Maintenance": {
      "category": "support",
      "name": "Maintenance",
      "rarity": "common"
    },
    "Doublehand": {
      "category": "support",
      "name": "Doublehand",
      "rarity": "rare"
    },
    "DualWield": {
      "category": "support",
      "name": "Dual Wield",
      "rarity": "rare"
    },
    "Defend": {
      "category": "support",
      "name": "Defend",
      "rarity": "common"
    },
    "ShortCharge": {
      "category": "support",
      "name": "Short Charge",
      "rarity": "rare"
    },
    "HalveMP": {
      "category": "support",
      "name": "Halve MP",
      "rarity": "common"
    },
    "Beastmaster": {
      "category": "support",
      "name": "Beastmaster",
      "rarity": "common"
    },
    "EquipArmor": {
      "category": "support",
      "name": "Equip Armor",
      "rarity": "common"
    },
    "EquipShield": {
      "category": "support",
      "name": "Equip Shield",
      "rarity": "common"
    },
    "EquipKnife": {
      "category": "support",
      "name": "Equip Knife",
      "rarity": "common"
    },
    "EquipBow": {
      "category": "support",
      "name": "Equip Bow",
      "rarity": "common"
    },
    "EquipSword": {
      "category": "support",
      "name": "Equip Sword",
      "rarity": "common"
    },
    "EquipGun": {
      "category": "support",
      "name": "Equip Gun",
      "rarity": "uncommon"
    },
    "EquipAxe": {
      "category": "support",
      "name": "Equip Axe",
      "rarity": "common"
    },
    "EquipPolearm": {
      "category": "support",
      "name": "Equip Polearm",
      "rarity": "common"
    },
    "SecretHunt": {
      "category": "support",
      "name": "Secret Hunt",
      "rarity": "common"
    },
    "Sicken": {
      "category": "support",
      "name": "Sicken",
      "rarity": "common"
    },
    "MonsterTalk": {
      "category": "support",
      "name": "Monster Talk",
      "rarity": "common"
    },
    "ThrowItem": {
      "category": "support",
      "name": "Throw Item",
      "rarity": "common"
    },
    "LongStatus": {
      "category": "support",
      "name": "Long Status",
      "rarity": "common"
    },
    "ShortStatus": {
      "category": "support",
      "name": "Short Status",
      "rarity": "common"
    },
    "CounterTackle": {
      "category": "reaction",
      "name": "Counter Tackle",
      "rarity": "common"
    },
    "AutoPotion": {
      "category": "reaction",
      "name": "Auto Potion",
      "rarity": "uncommon"
    },
    "Parry": {
      "category": "reaction",
      "name": "Parry",
      "rarity": "common"
    },
    "SpeedSave": {
      "category": "reaction",
      "name": "Speed Save",
      "rarity": "common"
    },
    "ArrowGuard": {
      "category": "reaction",
      "name": "Arrow Guard",
      "rarity": "common"
    },
    "HPRestore": {
      "category": "reaction",
      "name": "HP Restore",
      "rarity": "uncommon"
    },
    "Counter": {
      "category": "reaction",
      "name": "Counter",
      "rarity": "common"
    },
    "Hamedo": {
      "category": "reaction",
      "name": "Hamedo",
      "rarity": "rare"
    },
    "Regenerator": {
      "category": "reaction",
      "name": "Regenerator",
      "rarity": "common"
    },
    "CounterMagic": {
      "category": "reaction",
      "name": "Counter Magic",
      "rarity": "common"
    },
    "CriticalQuick": {
      "category": "reaction",
      "name": "Critical Quick",
      "rarity": "common"
    },
    "ManaShield": {
      "category": "reaction",
      "name": "Mana Shield",
      "rarity": "uncommon"
    },
    "MPRestore": {
      "category": "reaction",
      "name": "MP Restore",
      "rarity": "common"
    },
    "Caution": {
      "category": "reaction",
      "name": "Caution",
      "rarity": "common"
    },
    "Catch": {
      "category": "reaction",
      "name": "Catch",
      "rarity": "common"
    },
    "Earplug": {
      "category": "reaction",
      "name": "Earplug",
      "rarity": "common"
    },
    "AbsorbUsedMP": {
      "category": "reaction",
      "name": "Absorb Used MP",
      "rarity": "common"
    },
    "CounterFlood": {
      "category": "reaction",
      "name": "Counter Flood",
      "rarity": "common"
    },
    "DragonSpirit": {
      "category": "reaction",
      "name": "Dragon Spirit",
      "rarity": "common"
    },
    "MeatboneSlash": {
      "category": "reaction",
      "name": "Meatbone Slash",
      "rarity": "common"
    },
    "Abandon": {
      "category": "reaction",
      "name": "Abandon",
      "rarity": "common"
    },
    "Distribute": {
      "category": "reaction",
      "name": "Distribute",
      "rarity": "common"
    },
    "DamageSplit": {
      "category": "reaction",
      "name": "Damage Split",
      "rarity": "uncommon"
    },
    "PASave": {
      "category": "reaction",
      "name": "PA Save",
      "rarity": "common"
    },
    "MASave": {
      "category": "reaction",
      "name": "MA Save",
      "rarity": "common"
    },
    "BraveSave": {
      "category": "reaction",
      "name": "Brave Save",
      "rarity": "common"
    },
    "FaithSave": {
      "category": "reaction",
      "name": "Faith Save",
      "rarity": "common"
    },
    "SunkenState": {
      "category": "reaction",
      "name": "Sunken State",
      "rarity": "common"
    },
    "BasicSkill": {
      "category": "skillset",
      "name": "Basic Skill",
      "rarity": "common"
    },
    "Item": {
      "category": "skillset",
      "name": "Item",
      "rarity": "common"
    },
    "BattleSkill": {
      "category": "skillset",
      "name": "Battle Skill",
      "rarity": "common"
    },
    "Charge": {
      "category": "skillset",
      "name": "Charge",
      "rarity": "common"
    },
    "PunchArt": {
      "category": "skillset",
      "name": "Punch Art",
      "rarity": "common"
    },
    "WhiteMagic": {
      "category": "skillset",
      "name": "White Magic",
      "rarity": "common"
    },
    "BlackMagic": {
      "category": "skillset",
      "name": "Black Magic",
      "rarity": "common"
    },
    "TimeMagic": {
      "category": "skillset",
      "name": "Time Magic",
      "rarity": "common"
    },
    "SummonMagic": {
      "category": "skillset",
      "name": "Summon Magic",
      "rarity": "common"
    },
    "Steal": {
      "category": "skillset",
      "name": "Steal",
      "rarity": "common"
    },
    "TalkSkill": {
      "category": "skillset",
      "name": "Talk Skill",
      "rarity": "common"
    },
    "YinYangMagic": {
      "category": "skillset",
      "name": "Yin Yang Magic",
      "rarity": "common"
    },
    "Elemental": {
      "category": "skillset",
      "name": "Elemental",
      "rarity": "common"
    },
    "Jump": {
      "category": "skillset",
      "name": "Jump",
      "rarity": "common"
    },
    "DrawOut": {
      "category": "skillset",
      "name": "Draw Out",
      "rarity": "rare"
    },
    "Throw": {
      "category": "skillset",
      "name": "Throw",
      "rarity": "common"
    },
    "Dance": {
      "category": "skillset",
      "name": "Dance",
      "rarity": "common"
    },
    "Sing": {
      "category": "skillset",
      "name": "Sing",
      "rarity": "common"
    },
    "BlueMagic": {
      "category": "skillset",
      "name": "Blue Magic",
      "rarity": "common"
    },
    "Chocobo": {
      "category": "monster",
      "name": "Chocobo",
      "rarity": "common"
    },
    "BlackChocobo": {
      "category": "monster",
      "name": "Black Chocobo",
      "rarity": "common"
    },
    "RedChocobo": {
      "category": "monster",
      "name": "Red Chocobo",
      "rarity": "rare"
    },
    "Goblin": {
      "category": "monster",
      "name": "Goblin",
      "rarity": "common"
    },
    "BlackGoblin": {
      "category": "monster",
      "name": "Black Goblin",
      "rarity": "common"
    },
    "Gobbledeguck": {
      "category": "monster",
      "name": "Gobbledeguck",
      "rarity": "common"
    },
    "Bomb": {
      "category": "monster",
      "name": "Bomb",
      "rarity": "common"
    },
    "Grenade": {
      "category": "monster",
      "name": "Grenade",
      "rarity": "common"
    },
    "Explosive": {
      "category": "monster",
      "name": "Explosive",
      "rarity": "common"
    },
    "RedPanther": {
      "category": "monster",
      "name": "Red Panther",
      "rarity": "common"
    },
    "Coeurl": {
      "category": "monster",
      "name": "Coeurl",
      "rarity": "common"
    },
    "Vampire": {
      "category": "monster",
      "name": "Vampire",
      "rarity": "common"
    },
    "PiscoDemon": {
      "category": "monster",
      "name": "Pisco Demon",
      "rarity": "common"
    },
    "Squidraken": {
      "category": "monster",
      "name": "Squidraken",
      "rarity": "common"
    },
    "Mindflayer": {
      "category": "monster",
      "name": "Mindflayer",
      "rarity": "common"
    },
    "Skeleton": {
      "category": "monster",
      "name": "Skeleton",
      "rarity": "common"
    },
    "Draugr": {
      "category": "monster",
      "name": "Draugr",
      "rarity": "common"
    },
    "Reaper": {
      "category": "monster",
      "name": "Reaper",
      "rarity": "common"
    },
    "Ghoul": {
      "category": "monster",
      "name": "Ghoul",
      "rarity": "common"
    },
    "Ghost": {
      "category": "monster",
      "name": "Ghost",
      "rarity": "common"
    },
    "Revenant": {
      "category": "monster",
      "name": "Revenant",
      "rarity": "common"
    },
    "FloatingEye": {
      "category": "monster",
      "name": "Floating Eye",
      "rarity": "common"
    },
    "Ahriman": {
      "category": "monster",
      "name": "Ahriman",
      "rarity": "common"
    },
    "Plague": {
      "category": "monster",
      "name": "Plague",
      "rarity": "common"
    },
    "Juravis": {
      "category": "monster",
      "name": "Juravis",
      "rarity": "common"
    },
    "IronHawk": {
      "category": "monster",
      "name": "Iron Hawk",
      "rarity": "common"
    },
    "Cockatrice": {
      "category": "monster",
      "name": "Cockatrice",
      "rarity": "common"
    },
    "Swine": {
      "category": "monster",
      "name": "Swine",
      "rarity": "common"
    },
    "Porky": {
      "category": "monster",
      "name": "Porky",
      "rarity": "common"
    },
    "WildBoar": {
      "category": "monster",
      "name": "Wild Boar",
      "rarity": "common"
    },
    "Dryad": {
      "category": "monster",
      "name": "Dryad",
      "rarity": "common"
    },
    "Treant": {
      "category": "monster",
      "name": "Treant",
      "rarity": "common"
    },
    "Taiju": {
      "category": "monster",
      "name": "Taiju",
      "rarity": "common"
    },
    "BullDemon": {
      "category": "monster",
      "name": "Bull Demon",
      "rarity": "common"
    },
    "Minotaur": {
      "category": "monster",
      "name": "Minotaur",
      "rarity": "common"
    },
    "Sekhret": {
      "category": "monster",
      "name": "Sekhret",
      "rarity": "uncommon"
    },
    "Malboro": {
      "category": "monster",
      "name": "Malboro",
      "rarity": "common"
    },
    "Ochu": {
      "category": "monster",
      "name": "Ochu",
      "rarity": "common"
    },
    "GreatMalboro": {
      "category": "monster",
      "name": "Great Malboro",
      "rarity": "common"
    },
    "Behemoth": {
      "category": "monster",
      "name": "Behemoth",
      "rarity": "common"
    },
    "KingBehemoth": {
      "category": "monster",
      "name": "King Behemoth",
      "rarity": "uncommon"
    },
    "DarkBehemoth": {
      "category": "monster",
      "name": "Dark Behemoth",
      "rarity": "rare"
    },
    "Dragon": {
      "category": "monster",
      "name": "Dragon",
      "rarity": "uncommon"
    },
    "BlueDragon": {
      "category": "monster",
      "name": "Blue Dragon",
      "rarity": "uncommon"
    },
    "RedDragon": {
      "category": "monster",
      "name": "Red Dragon",
      "rarity": "uncommon"
    },
    "Wyvern": {
      "category": "monster",
      "name": "Wyvern",
      "rarity": "common"
    },
    "Hydra": {
      "category": "monster",
      "name": "Hydra",
      "rarity": "uncommon"
    },
    "Tiamat": {
      "category": "monster",
      "name": "Tiamat",
      "rarity": "rare"
    },
    "ArchaicDemon": {
      "category": "monster",
      "name": "Archaic Demon",
      "rarity": "uncommon"
    },
    "UltimaDemon": {
      "category": "monster",
      "name": "Ultima Demon",
      "rarity": "rare"
    },
    "Apanda": {
      "category": "monster",
      "name": "Apanda",
      "rarity": "uncommon"
    },
    "SteelGiant": {
      "category": "monster",
      "name": "Steel Giant",
      "rarity": "rare"
    },
    "Byblos": {
      "category": "monster",
      "name": "Byblos",
      "rarity": "rare"
    },
    "HolyDragon": {
      "category": "monster",
      "name": "Holy Dragon",
      "rarity": "rare"
    },
    "Serpentarius": {
      "category": "monster",
      "name": "Serpentarius",
      "rarity": "rare"
    },
    "BattleBoots": {
      "category": "accessory",
      "name": "Battle Boots",
      "rarity": "common"
    },
    "SpikeShoes": {
      "category": "accessory",
      "name": "Spike Shoes",
      "rarity": "common"
    },
    "GerminasBoots": {
      "category": "accessory",
      "name": "Germinas Boots",
      "rarity": "common"
    },
    "RubberShoes": {
      "category": "accessory",
      "name": "Rubber Shoes",
      "rarity": "common"
    },
    "FeatherBoots": {
      "category": "accessory",
      "name": "Feather Boots",
      "rarity": "common"
    },
    "SprintShoes": {
      "category": "accessory",
      "name": "Sprint Shoes",
      "rarity": "common"
    },
    "RedShoes": {
      "category": "accessory",
      "name": "Red Shoes",
      "rarity": "common"
    },
    "PowerWrist": {
      "category": "accessory",
      "name": "Power Wrist",
      "rarity": "common"
    },
    "MagicGauntlet": {
      "category": "accessory",
      "name": "Magic Gauntlet",
      "rarity": "common"
    },
    "Bracer": {
      "category": "accessory",
      "name": "Bracer",
      "rarity": "common"
    },
    "GenjiGauntlet": {
      "category": "accessory",
      "name": "Genji Gauntlet",
      "rarity": "rare"
    },
    "ReflectRing": {
      "category": "accessory",
      "name": "Reflect Ring",
      "rarity": "common"
    },
    "DefenseRing": {
      "category": "accessory",
      "name": "Defense Ring",
      "rarity": "common"
    },
    "MagicRing": {
      "category": "accessory",
      "name": "Magic Ring",
      "rarity": "common"
    },
    "CursedRing": {
      "category": "accessory",
      "name": "Cursed Ring",
      "rarity": "common"
    },
    "AngelRing": {
      "category": "accessory",
      "name": "Angel Ring",
      "rarity": "uncommon"
    },
    "DiamondArmlet": {
      "category": "accessory",
      "name": "Diamond Armlet",
      "rarity": "common"
    },
    "JadeArmlet": {
      "category": "accessory",
      "name": "Jade Armlet",
      "rarity": "common"
    },
    "108Gems": {
      "category": "accessory",
      "name": "108 Gems",
      "rarity": "common"
    },
    "N-KaiArmlet": {
      "category": "accessory",
      "name": "N-Kai Armlet",
      "rarity": "common"
    },
    "IronArmlet": {
      "category": "accessory",
      "name": "Iron Armlet",
      "rarity": "common"
    },
    "SmallMantle": {
      "category": "accessory",
      "name": "Small Mantle",
      "rarity": "common"
    },
    "LeatherMantle": {
      "category": "accessory",
      "name": "Leather Mantle",
      "rarity": "common"
    },
    "WizardMantle": {
      "category": "accessory",
      "name": "Wizard Mantle",
      "rarity": "common"
    },
    "ElfMantle": {
      "category": "accessory",
      "name": "Elf Mantle",
      "rarity": "common"
    },
    "DraculaMantle": {
      "category": "accessory",
      "name": "Dracula Mantle",
      "rarity": "common"
    },
    "FeatherMantle": {
      "category": "accessory",
      "name": "Feather Mantle",
      "rarity": "uncommon"
    },
    "VanishMantle": {
      "category": "accessory",
      "name": "Vanish Mantle",
      "rarity": "rare"
    },
    "BraveBoost": {
      "category": "meta",
      "name": "Brave Boost",
      "rarity": "common"
    },
    "FaithBoost": {
      "category": "meta",
      "name": "Faith Boost",
      "rarity": "common"
    },
    "EXPBoost": {
      "category": "meta",
      "name": "EXP Boost",
      "rarity": "common"
    },
    "NeutralZodiac": {
      "category": "meta",
      "name": "Neutral Zodiac",
      "rarity": "common"
    },
    "GearedUp": {
      "category": "meta",
      "name": "Geared Up",
      "rarity": "uncommon"
    },
    "HighlySkilled": {
      "category": "meta",
      "name": "Highly Skilled",
      "rarity": "uncommon"
    },
    "GilgameHeart": {
      "category": "meta",
      "name": "Gilgame Heart",
      "rarity": "common"
    },
    "FashionSense": {
      "category": "meta",
      "name": "Fashion Sense",
      "rarity": "common"
    },
    "RandomMonster": {
      "category": "meta",
      "name": "Random Monster",
      "rarity": "common"
    },
    "PreferredArms": {
      "category": "meta",
      "name": "Preferred Arms",
      "rarity": "uncommon"
    },
    "Teleport2": {
      "category": "movement",
      "name": "Teleport 2",
      "rarity": "rare"
    },
    "BladeGrasp": {
      "category": "reaction",
      "name": "Blade Grasp",
      "rarity": "rare"
    },
    "MathSkill": {
      "category": "skillset",
      "name": "Math Skill",
      "rarity": "rare"
    },
    "EquipPerfume": {
      "category": "support",
      "name": "Equip Perfume",
      "rarity": "rare"
    },
    "RaidBoss": {
      "category": "meta",
      "name": "Raid Boss",
      "rarity": "rare"
    },
    "Doppelganger": {
      "category": "meta",
      "name": "Doppelganger",
      "rarity": "rare"
    }
  },
  "categories": {
    "movement": [
      {
        "token": "Move+1",
        "name": "Move+1",
        "rarity": "common"
      },
      {
        "token": "Move+2",
        "name": "Move+2",
        "rarity": "common"
      },
      {
        "token": "Move+3",
        "name": "Move+3",
        "rarity": "uncommon"
      },
      {
        "token": "Jump+1",
        "name": "Jump+1",
        "rarity": "common"
      },
      {
        "token": "Jump+2",
        "name": "Jump+2",
        "rarity": "common"
      },
      {
        "token": "Jump+3",
        "name": "Jump+3",
        "rarity": "common"
      },
      {
        "token": "Lifefont",
        "name": "Lifefont",
        "rarity": "common"
      },
      {
        "token": "Teleport",
        "name": "Teleport",
        "rarity": "common"
      },
      {
        "token": "Levitate",
        "name": "Levitate",
        "rarity": "common"
      },
      {
        "token": "Pilgrimage",
        "name": "Pilgrimage",
        "rarity": "common"
      },
      {
        "token": "Manafont",
        "name": "Manafont",
        "rarity": "common"
      },
      {
        "token": "IgnoreTerrain",
        "name": "Ignore Terrain",
        "rarity": "common"
      },
      {
        "token": "LavaWalking",
        "name": "Lava Walking",
        "rarity": "common"
      },
      {
        "token": "IgnoreHeight",
        "name": "Ignore Height",
        "rarity": "common"
      },
      {
        "token": "Swim",
        "name": "Swim",
        "rarity": "common"
      },
      {
        "token": "Waterwalking",
        "name": "Waterwalking",
        "rarity": "common"
      },
      {
        "token": "Fly",
        "name": "Fly",
        "rarity": "common"
      },
      {
        "token": "Retreat",
        "name": "Retreat",
        "rarity": "common"
      },
      {
        "token": "SonicStep",
        "name": "Sonic Step",
        "rarity": "common"
      },
      {
        "token": "Teleport2",
        "name": "Teleport 2",
        "rarity": "rare"
      }
    ],
    "support": [
      {
        "token": "AttackUp",
        "name": "Attack Up",
        "rarity": "common"
      },
      {
        "token": "DefenseUp",
        "name": "Defense Up",
        "rarity": "common"
      },
      {
        "token": "MagicAttackUp",
        "name": "Magic Attack Up",
        "rarity": "common"
      },
      {
        "token": "MagicDefenseUp",
        "name": "Magic Defense Up",
        "rarity": "common"
      },
      {
        "token": "Concentrate",
        "name": "Concentrate",
        "rarity": "common"
      },
      {
        "token": "MartialArts",
        "name": "Martial Arts",
        "rarity": "common"
      },
      {
        "token": "Maintenance",
        "name": "Maintenance",
        "rarity": "common"
      },
      {
        "token": "Doublehand",
        "name": "Doublehand",
        "rarity": "rare"
      },
      {
        "token": "DualWield",
        "name": "Dual Wield",
        "rarity": "rare"
      },
      {
        "token": "Defend",
        "name": "Defend",
        "rarity": "common"
      },
      {
        "token": "ShortCharge",
        "name": "Short Charge",
        "rarity": "rare"
      },
      {
        "token": "HalveMP",
        "name": "Halve MP",
        "rarity": "common"
      },
      {
        "token": "Beastmaster",
        "name": "Beastmaster",
        "rarity": "common"
      },
      {
        "token": "EquipArmor",
        "name": "Equip Armor",
        "rarity": "common"
      },
      {
        "token": "EquipShield",
        "name": "Equip Shield",
        "rarity": "common"
      },
      {
        "token": "EquipKnife",
        "name": "Equip Knife",
        "rarity": "common"
      },
      {
        "token": "EquipBow",
        "name": "Equip Bow",
        "rarity": "common"
      },
      {
        "token": "EquipSword",
        "name": "Equip Sword",
        "rarity": "common"
      },
      {
        "token": "EquipGun",
        "name": "Equip Gun",
        "rarity": "uncommon"
      },
      {
        "token": "EquipAxe",
        "name": "Equip Axe",
        "rarity": "common"
      },
      {
        "token": "EquipPolearm",
        "name": "Equip Polearm",
        "rarity": "common"
      },
      {
        "token": "SecretHunt",
        "name": "Secret Hunt",
        "rarity": "common"
      },
      {
        "token": "Sicken",
        "name": "Sicken",
        "rarity": "common"
      },
      {
        "token": "MonsterTalk",
        "name": "Monster Talk",
        "rarity": "common"
      },
      {
        "token": "ThrowItem",
        "name": "Throw Item",
        "rarity": "common"
      },
      {
        "token": "LongStatus",
        "name": "Long Status",
        "rarity": "common"
      },
      {
        "token": "ShortStatus",
        "name": "Short Status",
        "rarity": "common"
      },
      {
        "token": "EquipPerfume",
        "name": "Equip Perfume",
        "rarity": "rare"
      }
    ],
    "reaction": [
      {
        "token": "CounterTackle",
        "name": "Counter Tackle",
        "rarity": "common"
      },
      {
        "token": "AutoPotion",
        "name": "Auto Potion",
        "rarity": "uncommon"
      },
      {
        "token": "Parry",
        "name": "Parry",
        "rarity": "common"
      },
      {
        "token": "SpeedSave",
        "name": "Speed Save",
        "rarity": "common"
      },
      {
        "token": "ArrowGuard",
        "name": "Arrow Guard",
        "rarity": "common"
      },
      {
        "token": "HPRestore",
        "name": "HP Restore",
        "rarity": "uncommon"
      },
      {
        "token": "Counter",
        "name": "Counter",
        "rarity": "common"
      },
      {
        "token": "Hamedo",
        "name": "Hamedo",
        "rarity": "rare"
      },
      {
        "token": "Regenerator",
        "name": "Regenerator",
        "rarity": "common"
      },
      {
        "token": "CounterMagic",
        "name": "Counter Magic",
        "rarity": "common"
      },
      {
        "token": "CriticalQuick",
        "name": "Critical Quick",
        "rarity": "common"
      },
      {
        "token": "ManaShield",
        "name": "Mana Shield",
        "rarity": "uncommon"
      },
      {
        "token": "MPRestore",
        "name": "MP Restore",
        "rarity": "common"
      },
      {
        "token": "Caution",
        "name": "Caution",
        "rarity": "common"
      },
      {
        "token": "Catch",
        "name": "Catch",
        "rarity": "common"
      },
      {
        "token": "Earplug",
        "name": "Earplug",
        "rarity": "common"
      },
      {
        "token": "AbsorbUsedMP",
        "name": "Absorb Used MP",
        "rarity": "common"
      },
      {
        "token": "CounterFlood",
        "name": "Counter Flood",
        "rarity": "common"
      },
      {
        "token": "DragonSpirit",
        "name": "Dragon Spirit",
        "rarity": "common"
      },
      {
        "token": "MeatboneSlash",
        "name": "Meatbone Slash",
        "rarity": "common"
      },
      {
        "token": "Abandon",
        "name": "Abandon",
        "rarity": "common"
      },
      {
        "token": "Distribute",
        "name": "Distribute",
        "rarity": "common"
      },
      {
        "token": "DamageSplit",
        "name": "Damage Split",
        "rarity": "uncommon"
      },
      {
        "token": "PASave",
        "name": "PA Save",
        "rarity": "common"
      },
      {
        "token": "MASave",
        "name": "MA Save",
        "rarity": "common"
      },
      {
        "token": "BraveSave",
        "name": "Brave Save",
        "rarity": "common"
      },
      {
        "token": "FaithSave",
        "name": "Faith Save",
        "rarity": "common"
      },
      {
        "token": "SunkenState",
        "name": "Sunken State",
        "rarity": "common"
      },
      {
        "token": "BladeGrasp",
        "name": "Blade Grasp",
        "rarity": "rare"
      }
    ],
    "skillset": [
      {
        "token": "BasicSkill",
        "name": "Basic Skill",
        "rarity": "common"
      },
      {
        "token": "Item",
        "name": "Item",
        "rarity": "common"
      },
      {
        "token": "BattleSkill",
        "name": "Battle Skill",
        "rarity": "common"
      },
      {
        "token": "Charge",
        "name": "Charge",
        "rarity": "common"
      },
      {
        "token": "PunchArt",
        "name": "Punch Art",
        "rarity": "common"
      },
      {
        "token": "WhiteMagic",
        "name": "White Magic",
        "rarity": "common"
      },
      {
        "token": "BlackMagic",
        "name": "Black Magic",
        "rarity": "common"
      },
      {
        "token": "TimeMagic",
        "name": "Time Magic",
        "rarity": "common"
      },
      {
        "token": "SummonMagic",
        "name": "Summon Magic",
        "rarity": "common"
      },
      {
        "token": "Steal",
        "name": "Steal",
        "rarity": "common"
      },
      {
        "token": "TalkSkill",
        "name": "Talk Skill",
        "rarity": "common"
      },
      {
        "token": "YinYangMagic",
        "name": "Yin Yang Magic",
        "rarity": "common"
      },
      {
        "token": "Elemental",
        "name": "Elemental",
        "rarity": "common"
      },
      {
        "token": "Jump",
        "name": "Jump",
        "rarity": "common"
      },
      {
        "token": "DrawOut",
        "name": "Draw Out",
        "rarity": "rare"
      },
      {
        "token": "Throw",
        "name": "Throw",
        "rarity": "common"
      },
      {
        "token": "Dance",
        "name": "Dance",
        "rarity": "common"
      },
      {
        "token": "Sing",
        "name": "Sing",
        "rarity": "common"
      },
      {
        "token": "BlueMagic",
        "name": "Blue Magic",
        "rarity": "common"
      },
      {
        "token": "MathSkill",
        "name": "Math Skill",
        "rarity": "rare"
      }
    ],
    "monster": [
      {
        "token": "Chocobo",
        "name": "Chocobo",
        "rarity": "common"
      },
      {
        "token": "BlackChocobo",
        "name": "Black Chocobo",
        "rarity": "common"
      },
      {
        "token": "RedChocobo",
        "name": "Red Chocobo",
        "rarity": "rare"
      },
      {
        "token": "Goblin",
        "name": "Goblin",
        "rarity": "common"
      },
      {
        "token": "BlackGoblin",
        "name": "Black Goblin",
        "rarity": "common"
      },
      {
        "token": "Gobbledeguck",
        "name": "Gobbledeguck",
        "rarity": "common"
      },
      {
        "token": "Bomb",
        "name": "Bomb",
        "rarity": "common"
      },
      {
        "token": "Grenade",
        "name": "Grenade",
        "rarity": "common"
      },
      {
        "token": "Explosive",
        "name": "Explosive",
        "rarity": "common"
      },
      {
        "token": "RedPanther",
        "name": "Red Panther",
        "rarity": "common"
      },
      {
        "token": "Coeurl",
        "name": "Coeurl",
        "rarity": "common"
      },
      {
        "token": "Vampire",
        "name": "Vampire",
        "rarity": "common"
      },
      {
        "token": "PiscoDemon",
        "name": "Pisco Demon",
        "rarity": "common"
      },
      {
        "token": "Squidraken",
        "name": "Squidraken",
        "rarity": "common"
      },
      {
        "token": "Mindflayer",
        "name": "Mindflayer",
        "rarity": "common"
      },
      {
        "token": "Skeleton",
        "name": "Skeleton",
        "rarity": "common"
      },
      {
        "token": "Draugr",
        "name": "Draugr",
        "rarity": "common"
      },
      {
        "token": "Reaper",
        "name": "Reaper",
        "rarity": "common"
      },
      {
        "token": "Ghoul",
        "name": "Ghoul",
        "rarity": "common"
      },
      {
        "token": "Ghost",
        "name": "Ghost",
        "rarity": "common"
      },
      {
        "token": "Revenant",
        "name": "Revenant",
        "rarity": "common"
      },
      {
        "token": "FloatingEye",
        "name": "Floating Eye",
        "rarity": "common"
      },
      {
        "token": "Ahriman",
        "name": "Ahriman",
        "rarity": "common"
      },
      {
        "token": "Plague",
        "name": "Plague",
        "rarity": "common"
      },
      {
        "token": "Juravis",
        "name": "Juravis",
        "rarity": "common"
      },
      {
        "token": "IronHawk",
        "name": "Iron Hawk",
        "rarity": "common"
      },
      {
        "token": "Cockatrice",
        "name": "Cockatrice",
        "rarity": "common"
      },
      {
        "token": "Swine",
        "name": "Swine",
        "rarity": "common"
      },
      {
        "token": "Porky",
        "name": "Porky",
        "rarity": "common"
      },
      {
        "token": "WildBoar",
        "name": "Wild Boar",
        "rarity": "common"
      },
      {
        "token": "Dryad",
        "name": "Dryad",
        "rarity": "common"
      },
      {
        "token": "Treant",
        "name": "Treant",
        "rarity": "common"
      },
      {
        "token": "Taiju",
        "name": "Taiju",
        "rarity": "common"
      },
      {
        "token": "BullDemon",
        "name": "Bull Demon",
        "rarity": "common"
      },
      {
        "token": "Minotaur",
        "name": "Minotaur",
        "rarity": "common"
      },
      {
        "token": "Sekhret",
        "name": "Sekhret",
        "rarity": "uncommon"
      },
      {
        "token": "Malboro",
        "name": "Malboro",
        "rarity": "common"
      },
      {
        "token": "Ochu",
        "name": "Ochu",
        "rarity": "common"
      },
      {
        "token": "GreatMalboro",
        "name": "Great Malboro",
        "rarity": "common"
      },
      {
        "token": "Behemoth",
        "name": "Behemoth",
        "rarity": "common"
      },
      {
        "token": "KingBehemoth",
        "name": "King Behemoth",
        "rarity": "uncommon"
      },
      {
        "token": "DarkBehemoth",
        "name": "Dark Behemoth",
        "rarity": "rare"
      },
      {
        "token": "Dragon",
        "name": "Dragon",
        "rarity": "uncommon"
      },
      {
        "token": "BlueDragon",
        "name": "Blue Dragon",
        "rarity": "uncommon"
      },
      {
        "token": "RedDragon",
        "name": "Red Dragon",
        "rarity": "uncommon"
      },
      {
        "token": "Wyvern",
        "name": "Wyvern",
        "rarity": "common"
      },
      {
        "token": "Hydra",
        "name": "Hydra",
        "rarity": "uncommon"
      },
      {
        "token": "Tiamat",
        "name": "Tiamat",
        "rarity": "rare"
      },
      {
        "token": "ArchaicDemon",
        "name": "Archaic Demon",
        "rarity": "uncommon"
      },
      {
        "token": "UltimaDemon",
        "name": "Ultima Demon",
        "rarity": "rare"
      },
      {
        "token": "Apanda",
        "name": "Apanda",
        "rarity": "uncommon"
      },
      {
        "token": "SteelGiant",
        "name": "Steel Giant",
        "rarity": "rare"
      },
      {
        "token": "Byblos",
        "name": "Byblos",
        "rarity": "rare"
      },
      {
        "token": "HolyDragon",
        "name": "Holy Dragon",
        "rarity": "rare"
      },
      {
        "token": "Serpentarius",
        "name": "Serpentarius",
        "rarity": "rare"
      }
    ],
    "accessory": [
      {
        "token": "BattleBoots",
        "name": "Battle Boots",
        "rarity": "common"
      },
      {
        "token": "SpikeShoes",
        "name": "Spike Shoes",
        "rarity": "common"
      },
      {
        "token": "GerminasBoots",
        "name": "Germinas Boots",
        "rarity": "common"
      },
      {
        "token": "RubberShoes",
        "name": "Rubber Shoes",
        "rarity": "common"
      },
      {
        "token": "FeatherBoots",
        "name": "Feather Boots",
        "rarity": "common"
      },
      {
        "token": "SprintShoes",
        "name": "Sprint Shoes",
        "rarity": "common"
      },
      {
        "token": "RedShoes",
        "name": "Red Shoes",
        "rarity": "common"
      },
      {
        "token": "PowerWrist",
        "name": "Power Wrist",
        "rarity": "common"
      },
      {
        "token": "MagicGauntlet",
        "name": "Magic Gauntlet",
        "rarity": "common"
      },
      {
        "token": "Bracer",
        "name": "Bracer",
        "rarity": "common"
      },
      {
        "token": "GenjiGauntlet",
        "name": "Genji Gauntlet",
        "rarity": "rare"
      },
      {
        "token": "ReflectRing",
        "name": "Reflect Ring",
        "rarity": "common"
      },
      {
        "token": "DefenseRing",
        "name": "Defense Ring",
        "rarity": "common"
      },
      {
        "token": "MagicRing",
        "name": "Magic Ring",
        "rarity": "common"
      },
      {
        "token": "CursedRing",
        "name": "Cursed Ring",
        "rarity": "common"
      },
      {
        "token": "AngelRing",
        "name": "Angel Ring",
        "rarity": "uncommon"
      },
      {
        "token": "DiamondArmlet",
        "name": "Diamond Armlet",
        "rarity": "common"
      },
      {
        "token": "JadeArmlet",
        "name": "Jade Armlet",
        "rarity": "common"
      },
      {
        "token": "108Gems",
        "name": "108 Gems",
        "rarity": "common"
      },
      {
        "token": "N-KaiArmlet",
        "name": "N-Kai Armlet",
        "rarity": "common"
      },
      {
        "token": "IronArmlet",
        "name": "Iron Armlet",
        "rarity": "common"
      },
      {
        "token": "SmallMantle",
        "name": "Small Mantle",
        "rarity": "common"
      },
      {
        "token": "LeatherMantle",
        "name": "Leather Mantle",
        "rarity": "common"
      },
      {
        "token": "WizardMantle",
        "name": "Wizard Mantle",
        "rarity": "common"
      },
      {
        "token": "ElfMantle",
        "name": "Elf Mantle",
        "rarity": "common"
      },
      {
        "token": "DraculaMantle",
        "name": "Dracula Mantle",
        "rarity": "common"
      },
      {
        "token": "FeatherMantle",
        "name": "Feather Mantle",
        "rarity": "uncommon"
      },
      {
        "token": "VanishMantle",
        "name": "Vanish Mantle",
        "rarity": "rare"
      }
    ],
    "meta": [
      {
        "token": "BraveBoost",
        "name": "Brave Boost",
        "rarity": "common"
      },
      {
        "token": "FaithBoost",
        "name": "Faith Boost",
        "rarity": "common"
      },
      {
        "token": "EXPBoost",
        "name": "EXP Boost",
        "rarity": "common"
      },
      {
        "token": "NeutralZodiac",
        "name": "Neutral Zodiac",
        "rarity": "common"
      },
      {
        "token": "GearedUp",
        "name": "Geared Up",
        "rarity": "uncommon"
      },
      {
        "token": "HighlySkilled",
        "name": "Highly Skilled",
        "rarity": "uncommon"
      },
      {
        "token": "GilgameHeart",
        "name": "Gilgame Heart",
        "rarity": "common"
      },
      {
        "token": "FashionSense",
        "name": "Fashion Sense",
        "rarity": "common"
      },
      {
        "token": "RandomMonster",
        "name": "Random Monster",
        "rarity": "common"
      },
      {
        "token": "PreferredArms",
        "name": "Preferred Arms",
        "rarity": "uncommon"
      },
      {
        "token": "RaidBoss",
        "name": "Raid Boss",
        "rarity": "rare"
      },
      {
        "token": "Doppelganger",
        "name": "Doppelganger",
        "rarity": "rare"
      }
    ]
  }
}
